import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import styles from './UnarchiveBundleDialog.module.css'
import { byDesign } from '@/infra/design'
import imgArchiveUrl from '@/assets/misc/img_archive.svg'
import DocumentsDisabledIllustration from '@/components/SpotIllustration/DocumentsDisabledIllustration'

export interface UnarchiveBundleDialogProps {
  showing: boolean
  onClose: () => unknown
  onUnarchive: () => unknown
  isUnarchivePending: boolean
  bundleName: string
  corporateMode: boolean
  testId?: string
}

export function UnarchiveBundleDialog({
  showing,
  onClose,
  onUnarchive,
  isUnarchivePending,
  bundleName,
  corporateMode,
  testId,
}: UnarchiveBundleDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isUnarchivePending ? undefined : onClose}
    >
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={imgArchiveUrl}
              illustration={byDesign(undefined, DocumentsDisabledIllustration)}
              alt="Unarchive bundle"
            />
          )}
          <h3 className={styles.title}>You’re about to unarchive a bundle</h3>
          <p className={styles.description}>
            Are you sure you want to unarchive the{' '}
            <span className={styles.bundleName}>{bundleName}</span> bundle? All
            jobs will be able to reference this bundle again.
          </p>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            isDisabled={isUnarchivePending}
            onPress={onClose}
            variant="default"
            testId={testId && `${testId}-close-unarchive-modal`}
          />
          <Button
            label="Unarchive"
            onPress={onUnarchive}
            isPending={isUnarchivePending}
            isDisabled={isUnarchivePending}
            variant="primary"
            testId={testId && `${testId}-modal-unarchive-button`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
